/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { IntlProvider } from 'react-intl';
import { notification } from 'antd';
import moment from 'moment';
import { find, get, pick, isNaN, values, merge, keyBy, uniq } from 'lodash';
import EN from '../locales/en_US';
import FR from '../locales/fr_BE';
import NL from '../locales/nl_BE';

export const locales = ['en', 'fr', 'nl'];
export const extraLocales = ['be_en', 'be_fr', 'be_nl', 'de_de'];

export const localeFields = [
    { abbr: 'en', name: 'english' },
    { abbr: 'fr', name: 'french' },
    { abbr: 'nl', name: 'dutch' },
];

export const extraLocaleFields = [
    { abbr: 'en', name: 'english' },
    { abbr: 'fr', name: 'french' },
    { abbr: 'nl', name: 'dutch' },
    { abbr: 'de', name: 'german' },
];

export const PREFIX_LOCALE = 'be_';

export const TVA_TYPES = [
    { value: 'Normal', label: 'Normal' },
    { value: 'Elections', label: '6%' },
];

export const PROPERTY_TYPES = ['CUSTOMIZATION', 'MANUFACTURING', 'FINISHING'];

export const CONFIGURATION_TYPES = ['CUSTOMIZATION', 'MANUFACTURING', 'FINISHING', 'OPTION', 'SERVICE', 'SHIPPING'];

export const CONFIGURATION_PROPERTY_TYPES = ['CUSTOMIZATION', 'MANUFACTURING', 'FINISHING'];

export const PUBLIC_URLS = ['401', '404', 'profile', 'dashboard', 'production', 'search'];

export const TIMES = ['00h', '01h', '02h', '03h', '04h', '05h', '06h', '07h', '08h', '09h', '10h', '11h', '12h', '13h', '14h', '15h', '16h', '17h', '18h', '19h', '20h', '21h', '22h', '23h'];

export const REGIONS = {
    LU: [{ key: 'lu', label: 'Luxembuorg' }],
    NL: [{ key: 'lb', label: 'Limburg' }],
    BE: [
        { key: 'an', label: 'Antwerpen' },
        { key: 'na', label: 'Namen' },
        { key: 'lg', label: 'Luik' },
        { key: 'bw', label: 'Waals-Brabant' },
        { key: 'hn', label: 'Henegouwen' },
        { key: 'bx', label: 'Brussel' },
        { key: 'vb', label: 'Vlaams-Brabant' },
        { key: 'ov', label: 'Oost-Vlaanderen' },
        { key: 'wv', label: 'West-Vlaanderen' },
    ],
};

export const CONTINENTS = ['EU', 'AF', 'AS', 'NA', 'SA', 'OC', 'AN'];

export const COUNTRIES = {
    AF: {
        countryCode: 'AF',
        translateId: 'countries.AF',
        continentCode: 'AS',
    },
    AX: {
        countryCode: 'AX',
        translateId: 'countries.AX',
        continentCode: 'EU',
    },
    AL: {
        countryCode: 'AL',
        translateId: 'countries.AL',
        continentCode: 'EU',
    },
    DZ: {
        countryCode: 'DZ',
        translateId: 'countries.DZ',
        continentCode: 'AF',
    },
    AS: {
        countryCode: 'AS',
        translateId: 'countries.AS',
        continentCode: 'OC',
    },
    AD: {
        countryCode: 'AD',
        translateId: 'countries.AD',
        continentCode: 'EU',
    },
    AO: {
        countryCode: 'AO',
        translateId: 'countries.AO',
        continentCode: 'AF',
    },
    AI: {
        countryCode: 'AI',
        translateId: 'countries.AI',
        continentCode: 'NA',
    },
    AQ: {
        countryCode: 'AQ',
        translateId: 'countries.AQ',
        continentCode: 'AN',
    },
    AG: {
        countryCode: 'AG',
        translateId: 'countries.AG',
        continentCode: 'NA',
    },
    AR: {
        countryCode: 'AR',
        translateId: 'countries.AR',
        continentCode: 'SA',
    },
    AM: {
        countryCode: 'AM',
        translateId: 'countries.AM',
        continentCode: 'AS',
    },
    AW: {
        countryCode: 'AW',
        translateId: 'countries.AW',
        continentCode: 'NA',
    },
    AU: {
        countryCode: 'AU',
        translateId: 'countries.AU',
        continentCode: 'OC',
    },
    AT: {
        countryCode: 'AT',
        translateId: 'countries.AT',
        continentCode: 'EU',
    },
    AZ: {
        countryCode: 'AZ',
        translateId: 'countries.AZ',
        continentCode: 'AS',
    },
    BS: {
        countryCode: 'BS',
        translateId: 'countries.BS',
        continentCode: 'NA',
    },
    BH: {
        countryCode: 'BH',
        translateId: 'countries.BH',
        continentCode: 'AS',
    },
    BD: {
        countryCode: 'BD',
        translateId: 'countries.BD',
        continentCode: 'AS',
    },
    BB: {
        countryCode: 'BB',
        translateId: 'countries.BB',
        continentCode: 'NA',
    },
    BY: {
        countryCode: 'BY',
        translateId: 'countries.BY',
        continentCode: 'EU',
    },
    BE: {
        countryCode: 'BE',
        translateId: 'countries.BE',
        continentCode: 'EU',
    },
    BZ: {
        countryCode: 'BZ',
        translateId: 'countries.BZ',
        continentCode: 'NA',
    },
    BJ: {
        countryCode: 'BJ',
        translateId: 'countries.BJ',
        continentCode: 'AF',
    },
    BM: {
        countryCode: 'BM',
        translateId: 'countries.BM',
        continentCode: 'NA',
    },
    BT: {
        countryCode: 'BT',
        translateId: 'countries.BT',
        continentCode: 'AS',
    },
    BO: {
        countryCode: 'BO',
        translateId: 'countries.BO',
        continentCode: 'SA',
    },
    BA: {
        countryCode: 'BA',
        translateId: 'countries.BA',
        continentCode: 'EU',
    },
    BW: {
        countryCode: 'BW',
        translateId: 'countries.BW',
        continentCode: 'AF',
    },
    BR: {
        countryCode: 'BR',
        translateId: 'countries.BR',
        continentCode: 'SA',
    },
    BN: {
        countryCode: 'BN',
        translateId: 'countries.BN',
        continentCode: 'AS',
    },
    BG: {
        countryCode: 'BG',
        translateId: 'countries.BG',
        continentCode: 'EU',
    },
    BF: {
        countryCode: 'BF',
        translateId: 'countries.BF',
        continentCode: 'AF',
    },
    BI: {
        countryCode: 'BI',
        translateId: 'countries.BI',
        continentCode: 'AF',
    },
    KH: {
        countryCode: 'KH',
        translateId: 'countries.KH',
        continentCode: 'AS',
    },
    CM: {
        countryCode: 'CM',
        translateId: 'countries.CM',
        continentCode: 'AF',
    },
    CA: {
        countryCode: 'CA',
        translateId: 'countries.CA',
        continentCode: 'NA',
    },
    CV: {
        countryCode: 'CV',
        translateId: 'countries.CV',
        continentCode: 'AF',
    },
    KY: {
        countryCode: 'KY',
        translateId: 'countries.KY',
        continentCode: 'NA',
    },
    CF: {
        countryCode: 'CF',
        translateId: 'countries.CF',
        continentCode: 'AF',
    },
    TD: {
        countryCode: 'TD',
        translateId: 'countries.TD',
        continentCode: 'AF',
    },
    CL: {
        countryCode: 'CL',
        translateId: 'countries.CL',
        continentCode: 'SA',
    },
    CN: {
        countryCode: 'CN',
        translateId: 'countries.CN',
        continentCode: 'AS',
    },
    CX: {
        countryCode: 'CX',
        translateId: 'countries.CX',
        continentCode: 'AS',
    },
    CC: {
        countryCode: 'CC',
        translateId: 'countries.CC',
        continentCode: 'AS',
    },
    CO: {
        countryCode: 'CO',
        translateId: 'countries.CO',
        continentCode: 'SA',
    },
    KM: {
        countryCode: 'KM',
        translateId: 'countries.KM',
        continentCode: 'AF',
    },
    CG: {
        countryCode: 'CG',
        translateId: 'countries.CG',
        continentCode: 'AF',
    },
    CD: {
        countryCode: 'CD',
        translateId: 'countries.CD',
        continentCode: 'AF',
    },
    CK: {
        countryCode: 'CK',
        translateId: 'countries.CK',
        continentCode: 'OC',
    },
    CR: {
        countryCode: 'CR',
        translateId: 'countries.CR',
        continentCode: 'NA',
    },
    CI: {
        countryCode: 'CI',
        translateId: 'countries.CI',
        continentCode: 'AF',
    },
    HR: {
        countryCode: 'HR',
        translateId: 'countries.HR',
        continentCode: 'EU',
    },
    CU: {
        countryCode: 'CU',
        translateId: 'countries.CU',
        continentCode: 'NA',
    },
    CY: {
        countryCode: 'CY',
        translateId: 'countries.CY',
        continentCode: 'AS',
    },
    CZ: {
        countryCode: 'CZ',
        translateId: 'countries.CZ',
        continentCode: 'EU',
    },
    DK: {
        countryCode: 'DK',
        translateId: 'countries.DK',
        continentCode: 'EU',
    },
    DJ: {
        countryCode: 'DJ',
        translateId: 'countries.DJ',
        continentCode: 'AF',
    },
    DM: {
        countryCode: 'DM',
        translateId: 'countries.DM',
        continentCode: 'NA',
    },
    DO: {
        countryCode: 'DO',
        translateId: 'countries.DO',
        continentCode: 'NA',
    },
    EC: {
        countryCode: 'EC',
        translateId: 'countries.EC',
        continentCode: 'SA',
    },
    EG: {
        countryCode: 'EG',
        translateId: 'countries.EG',
        continentCode: 'AF',
    },
    SV: {
        countryCode: 'SV',
        translateId: 'countries.SV',
        continentCode: 'NA',
    },
    GQ: {
        countryCode: 'GQ',
        translateId: 'countries.GQ',
        continentCode: 'AF',
    },
    ER: {
        countryCode: 'ER',
        translateId: 'countries.ER',
        continentCode: 'AF',
    },
    EE: {
        countryCode: 'EE',
        translateId: 'countries.EE',
        continentCode: 'EU',
    },
    ET: {
        countryCode: 'ET',
        translateId: 'countries.ET',
        continentCode: 'AF',
    },
    FO: {
        countryCode: 'FO',
        translateId: 'countries.FO',
        continentCode: 'EU',
    },
    FJ: {
        countryCode: 'FJ',
        translateId: 'countries.FJ',
        continentCode: 'OC',
    },
    FI: {
        countryCode: 'FI',
        translateId: 'countries.FI',
        continentCode: 'EU',
    },
    FR: {
        countryCode: 'FR',
        translateId: 'countries.FR',
        continentCode: 'EU',
    },
    GA: {
        countryCode: 'GA',
        translateId: 'countries.GA',
        continentCode: 'AF',
    },
    GM: {
        countryCode: 'GM',
        translateId: 'countries.GM',
        continentCode: 'AF',
    },
    GE: {
        countryCode: 'GE',
        translateId: 'countries.GE',
        continentCode: 'AS',
    },
    DE: {
        countryCode: 'DE',
        translateId: 'countries.DE',
        continentCode: 'EU',
    },
    GH: {
        countryCode: 'GH',
        translateId: 'countries.GH',
        continentCode: 'AF',
    },
    GI: {
        countryCode: 'GI',
        translateId: 'countries.GI',
        continentCode: 'EU',
    },
    GR: {
        countryCode: 'GR',
        translateId: 'countries.GR',
        continentCode: 'EU',
    },
    GL: {
        countryCode: 'GL',
        translateId: 'countries.GL',
        continentCode: 'NA',
    },
    GD: {
        countryCode: 'GD',
        translateId: 'countries.GD',
        continentCode: 'NA',
    },
    GU: {
        countryCode: 'GU',
        translateId: 'countries.GU',
        continentCode: 'OC',
    },
    GT: {
        countryCode: 'GT',
        translateId: 'countries.GT',
        continentCode: 'NA',
    },
    GG: {
        countryCode: 'GG',
        translateId: 'countries.GG',
        continentCode: 'EU',
    },
    GN: {
        countryCode: 'GN',
        translateId: 'countries.GN',
        continentCode: 'AF',
    },
    GW: {
        countryCode: 'GW',
        translateId: 'countries.GW',
        continentCode: 'AF',
    },
    GY: {
        countryCode: 'GY',
        translateId: 'countries.GY',
        continentCode: 'SA',
    },
    HT: {
        countryCode: 'HT',
        translateId: 'countries.HT',
        continentCode: 'NA',
    },
    VA: {
        countryCode: 'VA',
        translateId: 'countries.VA',
        continentCode: 'EU',
    },
    HN: {
        countryCode: 'HN',
        translateId: 'countries.HN',
        continentCode: 'NA',
    },
    HK: {
        countryCode: 'HK',
        translateId: 'countries.HK',
        continentCode: 'AS',
    },
    HU: {
        countryCode: 'HU',
        translateId: 'countries.HU',
        continentCode: 'EU',
    },
    IS: {
        countryCode: 'IS',
        translateId: 'countries.IS',
        continentCode: 'EU',
    },
    IN: {
        countryCode: 'IN',
        translateId: 'countries.IN',
        continentCode: 'AS',
    },
    ID: {
        countryCode: 'ID',
        translateId: 'countries.ID',
        continentCode: 'AS',
    },
    IR: {
        countryCode: 'IR',
        translateId: 'countries.IR',
        continentCode: 'AS',
    },
    IQ: {
        countryCode: 'IQ',
        translateId: 'countries.IQ',
        continentCode: 'AS',
    },
    IE: {
        countryCode: 'IE',
        translateId: 'countries.IE',
        continentCode: 'EU',
    },
    IM: {
        countryCode: 'IM',
        translateId: 'countries.IM',
        continentCode: 'EU',
    },
    IT: {
        countryCode: 'IT',
        translateId: 'countries.IT',
        continentCode: 'EU',
    },
    JM: {
        countryCode: 'JM',
        translateId: 'countries.JM',
        continentCode: 'NA',
    },
    JP: {
        countryCode: 'JP',
        translateId: 'countries.JP',
        continentCode: 'AS',
    },
    JE: {
        countryCode: 'JE',
        translateId: 'countries.JE',
        continentCode: 'EU',
    },
    JO: {
        countryCode: 'JO',
        translateId: 'countries.JO',
        continentCode: 'AS',
    },
    KZ: {
        countryCode: 'KZ',
        translateId: 'countries.KZ',
        continentCode: 'AS',
    },
    KE: {
        countryCode: 'KE',
        translateId: 'countries.KE',
        continentCode: 'AF',
    },
    KI: {
        countryCode: 'KI',
        translateId: 'countries.KI',
        continentCode: 'OC',
    },
    KP: {
        countryCode: 'KP',
        translateId: 'countries.KP',
        continentCode: 'AS',
    },
    KR: {
        countryCode: 'KR',
        translateId: 'countries.KR',
        continentCode: 'AS',
    },
    KW: {
        countryCode: 'KW',
        translateId: 'countries.KW',
        continentCode: 'AS',
    },
    KG: {
        countryCode: 'KG',
        translateId: 'countries.KG',
        continentCode: 'AS',
    },
    LA: {
        countryCode: 'LA',
        translateId: 'countries.LA',
        continentCode: 'AS',
    },
    LV: {
        countryCode: 'LV',
        translateId: 'countries.LV',
        continentCode: 'EU',
    },
    LB: {
        countryCode: 'LB',
        translateId: 'countries.LB',
        continentCode: 'AS',
    },
    LS: {
        countryCode: 'LS',
        translateId: 'countries.LS',
        continentCode: 'AF',
    },
    LR: {
        countryCode: 'LR',
        translateId: 'countries.LR',
        continentCode: 'AF',
    },
    LY: {
        countryCode: 'LY',
        translateId: 'countries.LY',
        continentCode: 'AF',
    },
    LI: {
        countryCode: 'LI',
        translateId: 'countries.LI',
        continentCode: 'EU',
    },
    LT: {
        countryCode: 'LT',
        translateId: 'countries.LT',
        continentCode: 'EU',
    },
    LU: {
        countryCode: 'LU',
        translateId: 'countries.LU',
        continentCode: 'EU',
    },
    MO: {
        countryCode: 'MO',
        translateId: 'countries.MO',
        continentCode: 'AS',
    },
    MK: {
        countryCode: 'MK',
        translateId: 'countries.MK',
        continentCode: 'EU',
    },
    MG: {
        countryCode: 'MG',
        translateId: 'countries.MG',
        continentCode: 'AF',
    },
    MW: {
        countryCode: 'MW',
        translateId: 'countries.MW',
        continentCode: 'AF',
    },
    MY: {
        countryCode: 'MY',
        translateId: 'countries.MY',
        continentCode: 'AS',
    },
    MV: {
        countryCode: 'MV',
        translateId: 'countries.MV',
        continentCode: 'AS',
    },
    ML: {
        countryCode: 'ML',
        translateId: 'countries.ML',
        continentCode: 'AF',
    },
    MT: {
        countryCode: 'MT',
        translateId: 'countries.MT',
        continentCode: 'EU',
    },
    MH: {
        countryCode: 'MH',
        translateId: 'countries.MH',
        continentCode: 'OC',
    },
    MQ: {
        countryCode: 'MQ',
        translateId: 'countries.MQ',
        continentCode: 'NA',
    },
    MR: {
        countryCode: 'MR',
        translateId: 'countries.MR',
        continentCode: 'AF',
    },
    MU: {
        countryCode: 'MU',
        translateId: 'countries.MU',
        continentCode: 'AF',
    },
    MX: {
        countryCode: 'MX',
        translateId: 'countries.MX',
        continentCode: 'NA',
    },
    FM: {
        countryCode: 'FM',
        translateId: 'countries.FM',
        continentCode: 'OC',
    },
    MD: {
        countryCode: 'MD',
        translateId: 'countries.MD',
        continentCode: 'EU',
    },
    MC: {
        countryCode: 'MC',
        translateId: 'countries.MC',
        continentCode: 'EU',
    },
    MN: {
        countryCode: 'MN',
        translateId: 'countries.MN',
        continentCode: 'AS',
    },
    MS: {
        countryCode: 'MS',
        translateId: 'countries.MS',
        continentCode: 'NA',
    },
    MA: {
        countryCode: 'MA',
        translateId: 'countries.MA',
        continentCode: 'AF',
    },
    MZ: {
        countryCode: 'MZ',
        translateId: 'countries.MZ',
        continentCode: 'AF',
    },
    MM: {
        countryCode: 'MM',
        translateId: 'countries.MM',
        continentCode: 'AS',
    },
    NA: {
        countryCode: 'NA',
        translateId: 'countries.NA',
        continentCode: 'AF',
    },
    NR: {
        countryCode: 'NR',
        translateId: 'countries.NR',
        continentCode: 'OC',
    },
    NP: {
        countryCode: 'NP',
        translateId: 'countries.NP',
        continentCode: 'AS',
    },
    NL: {
        countryCode: 'NL',
        translateId: 'countries.NL',
        continentCode: 'EU',
    },
    AN: {
        countryCode: 'AN',
        translateId: 'countries.AN',
        continentCode: 'NA',
    },
    NC: {
        countryCode: 'NC',
        translateId: 'countries.NC',
        continentCode: 'OC',
    },
    NZ: {
        countryCode: 'NZ',
        translateId: 'countries.NZ',
        continentCode: 'OC',
    },
    NI: {
        countryCode: 'NI',
        translateId: 'countries.NI',
        continentCode: 'NA',
    },
    NE: {
        countryCode: 'NE',
        translateId: 'countries.NE',
        continentCode: 'AF',
    },
    NG: {
        countryCode: 'NG',
        translateId: 'countries.NG',
        continentCode: 'AF',
    },
    NU: {
        countryCode: 'NU',
        translateId: 'countries.NU',
        continentCode: 'OC',
    },
    NF: {
        countryCode: 'NF',
        translateId: 'countries.NF',
        continentCode: 'OC',
    },
    MP: {
        countryCode: 'MP',
        translateId: 'countries.MP',
        continentCode: 'OC',
    },
    NO: {
        countryCode: 'NO',
        translateId: 'countries.NO',
        continentCode: 'EU',
    },
    OM: {
        countryCode: 'OM',
        translateId: 'countries.OM',
        continentCode: 'AS',
    },
    PK: {
        countryCode: 'PK',
        translateId: 'countries.PK',
        continentCode: 'AS',
    },
    PW: {
        countryCode: 'PW',
        translateId: 'countries.PW',
        continentCode: 'OC',
    },
    PS: {
        countryCode: 'PS',
        translateId: 'countries.PS',
        continentCode: 'AS',
    },
    PA: {
        countryCode: 'PA',
        translateId: 'countries.PA',
        continentCode: 'NA',
    },
    PG: {
        countryCode: 'PG',
        translateId: 'countries.PG',
        continentCode: 'OC',
    },
    PY: {
        countryCode: 'PY',
        translateId: 'countries.PY',
        continentCode: 'SA',
    },
    PE: {
        countryCode: 'PE',
        translateId: 'countries.PE',
        continentCode: 'SA',
    },
    PH: {
        countryCode: 'PH',
        translateId: 'countries.PH',
        continentCode: 'AS',
    },
    PN: {
        countryCode: 'PN',
        translateId: 'countries.PN',
        continentCode: 'OC',
    },
    PL: {
        countryCode: 'PL',
        translateId: 'countries.PL',
        continentCode: 'EU',
    },
    PT: {
        countryCode: 'PT',
        translateId: 'countries.PT',
        continentCode: 'EU',
    },
    PR: {
        countryCode: 'PR',
        translateId: 'countries.PR',
        continentCode: 'NA',
    },
    QA: {
        countryCode: 'QA',
        translateId: 'countries.QA',
        continentCode: 'AS',
    },
    RO: {
        countryCode: 'RO',
        translateId: 'countries.RO',
        continentCode: 'EU',
    },
    RU: {
        countryCode: 'RU',
        translateId: 'countries.RU',
        continentCode: 'AS',
    },
    RW: {
        countryCode: 'RW',
        translateId: 'countries.RW',
        continentCode: 'AF',
    },
    SH: {
        countryCode: 'SH',
        translateId: 'countries.SH',
        continentCode: 'AF',
    },
    KN: {
        countryCode: 'KN',
        translateId: 'countries.KN',
        continentCode: 'NA',
    },
    LC: {
        countryCode: 'LC',
        translateId: 'countries.LC',
        continentCode: 'NA',
    },
    SM: {
        countryCode: 'SM',
        translateId: 'countries.SM',
        continentCode: 'EU',
    },
    ST: {
        countryCode: 'ST',
        translateId: 'countries.ST',
        continentCode: 'AF',
    },
    SA: {
        countryCode: 'SA',
        translateId: 'countries.SA',
        continentCode: 'AS',
    },
    SN: {
        countryCode: 'SN',
        translateId: 'countries.SN',
        continentCode: 'AF',
    },
    RS: {
        countryCode: 'RS',
        translateId: 'countries.RS',
        continentCode: 'EU',
    },
    SC: {
        countryCode: 'SC',
        translateId: 'countries.SC',
        continentCode: 'AF',
    },
    SL: {
        countryCode: 'SL',
        translateId: 'countries.SL',
        continentCode: 'AF',
    },
    SG: {
        countryCode: 'SG',
        translateId: 'countries.SG',
        continentCode: 'AS',
    },
    SK: {
        countryCode: 'SK',
        translateId: 'countries.SK',
        continentCode: 'EU',
    },
    SI: {
        countryCode: 'SI',
        translateId: 'countries.SI',
        continentCode: 'EU',
    },
    SB: {
        countryCode: 'SB',
        translateId: 'countries.SB',
        continentCode: 'OC',
    },
    SO: {
        countryCode: 'SO',
        translateId: 'countries.SO',
        continentCode: 'AF',
    },
    ZA: {
        countryCode: 'ZA',
        translateId: 'countries.ZA',
        continentCode: 'AF',
    },
    ES: {
        countryCode: 'ES',
        translateId: 'countries.ES',
        continentCode: 'EU',
    },
    LK: {
        countryCode: 'LK',
        translateId: 'countries.LK',
        continentCode: 'AS',
    },
    SD: {
        countryCode: 'SD',
        translateId: 'countries.SD',
        continentCode: 'AF',
    },
    SR: {
        countryCode: 'SR',
        translateId: 'countries.SR',
        continentCode: 'SA',
    },
    SZ: {
        countryCode: 'SZ',
        translateId: 'countries.SZ',
        continentCode: 'AF',
    },
    SE: {
        countryCode: 'SE',
        translateId: 'countries.SE',
        continentCode: 'EU',
    },
    CH: {
        countryCode: 'CH',
        translateId: 'countries.CH',
        continentCode: 'EU',
    },
    SY: {
        countryCode: 'SY',
        translateId: 'countries.SY',
        continentCode: 'AS',
    },
    TW: {
        countryCode: 'TW',
        translateId: 'countries.TW',
        continentCode: 'AS',
    },
    TJ: {
        countryCode: 'TJ',
        translateId: 'countries.TJ',
        continentCode: 'AS',
    },
    TZ: {
        countryCode: 'TZ',
        translateId: 'countries.TZ',
        continentCode: 'AF',
    },
    TH: {
        countryCode: 'TH',
        translateId: 'countries.TH',
        continentCode: 'AS',
    },
    TL: {
        countryCode: 'TL',
        translateId: 'countries.TL',
        continentCode: 'AS',
    },
    TG: {
        countryCode: 'TG',
        translateId: 'countries.TG',
        continentCode: 'AF',
    },
    TK: {
        countryCode: 'TK',
        translateId: 'countries.TK',
        continentCode: 'OC',
    },
    TO: {
        countryCode: 'TO',
        translateId: 'countries.TO',
        continentCode: 'OC',
    },
    TT: {
        countryCode: 'TT',
        translateId: 'countries.TT',
        continentCode: 'NA',
    },
    TN: {
        countryCode: 'TN',
        translateId: 'countries.TN',
        continentCode: 'AF',
    },
    TR: {
        countryCode: 'TR',
        translateId: 'countries.TR',
        continentCode: 'AS',
    },
    TM: {
        countryCode: 'TM',
        translateId: 'countries.TM',
        continentCode: 'AS',
    },
    TC: {
        countryCode: 'TC',
        translateId: 'countries.TC',
        continentCode: 'NA',
    },
    TV: {
        countryCode: 'TV',
        translateId: 'countries.TV',
        continentCode: 'OC',
    },
    UG: {
        countryCode: 'UG',
        translateId: 'countries.UG',
        continentCode: 'AF',
    },
    UA: {
        countryCode: 'UA',
        translateId: 'countries.UA',
        continentCode: 'EU',
    },
    AE: {
        countryCode: 'AE',
        translateId: 'countries.AE',
        continentCode: 'AS',
    },
    GB: {
        countryCode: 'GB',
        translateId: 'countries.GB',
        continentCode: 'EU',
    },
    US: {
        countryCode: 'US',
        translateId: 'countries.US',
        continentCode: 'NA',
    },
    UY: {
        countryCode: 'UY',
        translateId: 'countries.UY',
        continentCode: 'SA',
    },
    UZ: {
        countryCode: 'UZ',
        translateId: 'countries.UZ',
        continentCode: 'AS',
    },
    VU: {
        countryCode: 'VU',
        translateId: 'countries.VU',
        continentCode: 'OC',
    },
    VE: {
        countryCode: 'VE',
        translateId: 'countries.VE',
        continentCode: 'SA',
    },
    VN: {
        countryCode: 'VN',
        translateId: 'countries.VN',
        continentCode: 'AS',
    },
    VI: {
        countryCode: 'VI',
        translateId: 'countries.VI',
        continentCode: 'NA',
    },
    YE: {
        countryCode: 'YE',
        translateId: 'countries.YE',
        continentCode: 'AS',
    },
    ZM: {
        countryCode: 'ZM',
        translateId: 'countries.ZM',
        continentCode: 'AF',
    },
    ZW: {
        countryCode: 'ZW',
        translateId: 'countries.ZW',
        continentCode: 'AF',
    },
};

export const daysOfTheWeek = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
];

export const coloredDays = {
    Monday: 'volcano',
    Tuesday: 'red',
    Wednesday: 'geekblue',
    Thursday: 'orange',
    Friday: 'gold',
    Saturday: 'cyan',
    Sunday: 'lime',
};

export const COST_TYPES = [
    { value: 'ECONOMIC', text: 'ECONOMIC' },
    { value: 'STANDARD', text: 'STANDARD' },
    { value: 'EXPRESS', text: 'EXPRESS' },
];

export const PP_COLORS = {
    WAITING_FOR_MANUFACTURING: 'orange',
    PLANNED: 'geekblue',
    IN_PROGRESS: 'blue',
    DONE: 'green',
};

export const ROUTES = {
    advancedSettings: { id: 'navigation.advancedSettings', icon: 'tools' },
    users: { id: 'navigation.users', icon: 'users' },
    marketing: { id: 'navigation.marketing', icon: 'bullhorn' },
    productFactory: { id: 'navigation.productFactory', icon: 'cog' },
    crm: { id: 'navigation.crm', icon: 'users-cog' },
    pp: { id: 'navigation.productionPlanning', icon: 'industry' },
    production: { id: 'navigation.production', icon: 'clipboard-list' },
    designLibrary: { id: 'navigation.designLibrary', icon: 'icons' },
    logistics: { id: 'navigation.logistics', icon: 'truck' },
    accountancy: { id: 'navigation.accountancy', icon: 'calculator' },
    statistics: { id: 'navigation.statistics', icon: 'calculator' },
};

export const IMPORT_SECTIONS_ROUTES = {
    SELLING_PRICE: [ROUTES.marketing, { to: '/marketing/products_groups/', id: 'navigation.productgroups' }],
    COST_AND_DURATIONS: [{ to: '/costs/', id: 'navigation.costs', icon: 'euro' }],
    TRANSLATE: [ROUTES.marketing, { to: '/marketing/translations/', id: 'navigation.translations' }],
};

export const QUALITY_BG_COLORS = {
    200: '#7c8c66',
    b200: '#6e4639',
    201: '#b30000',
    334: '#27f2a4',
    352: '#009200',
    411: '#00baff',
    5501: '#454545',
    5500: '#fdfed1',
    b411: '#1bcf00',
    413: '#3264f0',
    414: '#0082B0',
    415: '#3366FF',
    498: '#e966e9',
    499: '#ffccff',
    500: '#fb70ff',
    b500: '#e8e8e8',
    600: '#ffee00',
    b600: '#e89f00',
    607: '#D96005',
    610: '#fff59e',
    700: '#8200ad',
    b700: '#4f006b',
    701: '#000000',
    705: '#6600cc',
    1001: '#b4c6e7',
    1002: '#7496d2',
    1003: '#DAE9F8',
    1004: '#365FA8',
    1005: '#C1EDF7',
    b1002: '#c1f0c8',
    b1005: '#c1f0c8',
    2000: '#5c6100',
    2010: '#b1f748',
    2015: '#006161',
    2020: '#ff0099',
    2021: '#000000',
    reservation: '#f15609',
    new: '#07b00d',
    default: '#454545',
};

export const QUALITY_CODES = {
    200: 'Jewel',
    201: 'Pearl',
    334: 'Country',
    352: 'Extera',
    411: 'Globos Soft',
    5501: 'Globos Soft HYGIENE PLUS',
    5500: 'Patio HYGIENE PLUS',
    413: 'Melody',
    414: 'Gloria',
    415: 'Grande',
    498: 'Viva light rol',
    499: 'Viva light mat',
    500: 'Viva',
    600: 'Patio',
    607: 'Impact Pro',
    610: 'Level',
    700: 'Velvet',
    701: 'Velvet X',
    705: 'Volta',
    1001: 'Prestige',
    1002: 'Elegance',
    1003: 'Elegance Eco',
    1004: 'Essenza',
    1005: 'Elegance Pro',
    2000: 'Bolt',
    2010: 'Beau',
    2015: 'Mika',
    2020: 'Picnic',
    2021: 'Joy',
};

export const IMPORT_ROUTE = {
    COST_AND_DURATIONS: '/costs/imports',
    TRANSLATE: '/marketing/translations/imports',
};

export const QUILL_MODULES = {
    toolbar: [
        [{ header: '1' }, { header: '2' }, { font: [] }],
        [{ size: [] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
            { list: 'ordered' }, { list: 'bullet' },
            { indent: '-1' }, { indent: '+1' },
        ],
        ['link', 'image'],
        ['clean'],
    ],
    clipboard: {
        matchVisual: false, // toggle to add extra line breaks when pasting HTML:
    },
};

export const WORKFLOW_STEPS = [
    'NEW',
    'WAIT_FOR_FILE',
    'WAITING_FOR_MANUFACTURING',
    'MANUFACTURING',
    'SHIPPING',
    'SHIPPED',
    'READY_FOR_PICKUP',
    'PICKEDUP',
    'DELIVERED',
];

export const ORDER_STATES = [
    'RECEIVED',
    'FILE_CHECKING',
    'MANUFACTURED',
    'MANUFACTURING',
    'WAITING_FOR_MANUFACTURING',
    'SHIPPED',
    'SHIPPING',
    'REPRINT',
    'WAIT_FOR_FILE_CHANGE',
    'WAIT_FOR_FILE',
    'SHIPPING_RETURNED',
    'CLOSED',
    'CANCELED',
    'DELETED',
];

export const FETCH_SELECT_PROPS = {
    size: 'large',
    mode: 'default',
    filterOption: false,
    showArrow: true,
    showSearch: true,
    className: 'gx-w-100',
};

export const SELL_PRICES_STANDARDS = ['standard', 'standard_2', 'standard_3', 'standard_4'];

export const EXTRA_TRANSLATION_TYPES = ['BANNER', 'FRONT', 'DESIGNTOOL'];

export const SOURCE_TYPES = ['ADMIN', 'API', 'WEBSITE', 'INTEX'];

export const TRANSLATION_TYPE_ROUTES = {
    CARRIER: '/factory/carriers',
    PROPERTY: '/factory/properties/',
    PROPERTY_VALUE: '/factory/properties/',
    CONFIGURATION: '/factory/configurations/',
    'PRODUCT-GROUP': '/marketing/products_groups/',
    SEGMENT: '/marketing/segments/',
};

export const TRANSLATION_EDIT_ROUTES = {
    CARRIER: '/factory/carriers/edit/',
    PROPERTY: '/factory/properties/edit/',
    PROPERTY_VALUE: '/factory/property_values/edit/',
    CONFIGURATION: '/factory/configurations/edit/',
    'PRODUCT-GROUP': '/marketing/products_groups/edit/',
    SEGMENT: '/marketing/segments/edit/',
};

export const TYPE_TITLES = {
    CARRIER: 'name',
    PROPERTY: 'name.translate',
    PROPERTY_VALUE: 'name.translate',
    CONFIGURATION: 'name.translate',
    'PRODUCT-GROUP': 'name',
    SEGMENT: 'title',
    DISCOUNT: 'title.translate',
    PROMOTION: 'title.translate',
    BANNER: 'tag',
    FRONT: 'tag',
    DESIGNTOOL: 'tag',
};

export const ADMIN_UNIT = {
    printconcept: 'mm',
    mercuryflooring: 'cm',
};

export const ADMIN_CUSTOMER_ID = {
    printconcept: 'customer_number',
    mercuryflooring: 'external_id',
};

export const ADMIN_CUSTOMER_TYPEOF = {
    printconcept: v => parseInt(v, 10),
    mercuryflooring: v => `${v}`,
};

export const errorReasons = [
    'jobs.error.reason.tuft_manufacturing_error',
    'jobs.error.reason.tuft_white_spots',
    'jobs.error.reason.tuft_folds',
    'jobs.error.reason.tuft_backing',
    'jobs.error.reason.tuft_other',
    'jobs.error.reason.colaris_seam',
    'jobs.error.reason.colaris_touch_printhead',
    'jobs.error.reason.colaris_length_stripes',
    'jobs.error.reason.colaris_width_stripes',
    'jobs.error.reason.colaris_blurred',
    'jobs.error.reason.colaris_ink_spots',
    'jobs.error.reason.colaris_washout',
    'jobs.error.reason.colaris_other',
    'jobs.error.reason.cutting_framing',
    'jobs.error.reason.cutting_size',
    'jobs.error.reason.cutting_bad_program',
    'jobs.error.reason.cutting_other',
    'jobs.error.reason.coating_border_to_small',
    'jobs.error.reason.coating_border_fluff',
    'jobs.error.reason.coating_adhesion',
    'jobs.error.reason.coating_bubbels',
    'jobs.error.reason.coating_other',
    'jobs.error.reason.quantity_to_many',
    'jobs.error.reason.quantity_to_little',
];

/**
 * Filter the options by input. This function is linked to filterOption prop of Antd Select component.
 * @param {string} input The input entered by user.
 * @param {Object} option The options of select
 */
export function filterOptionForSelection(input, option) {
    const searchInput = new RegExp(input.toLowerCase(), 'g');
    return option.props.children.toString().toLowerCase().search(searchInput) >= 0;
}

/**
 * The value of this constant represent the proprieties to activate search in Ant design select
 */
export const searchSelectProps = {
    optionFilterProp: 'children',
    filterOption: filterOptionForSelection,
    showSearch: true,
    showArrow: true,
    className: 'gx-w-100',
    onMouseDown: e => e.preventDefault(),
    autoClearSearchValue: false,
};


/**
 * The role of this function is to return generated string of action type merged with status. This funtion is always used with AJAX requests for Redux
 * @param {string} action This parameter represents the action types of Redux
 * @param {string} status This parameter can be req, res, err
 * @example
 *
 *      actionCreator('GET_USER_DATA', 'res');
 *      => GET_USER_DATA_SUCCESS
 *
 *      actionCreator('GET_USER_DATA', 'err');
 *      => GET_USER_DATA_FAILED
 *
 * @returns {string}
 * @author Youssef Lahssini
 */
export function actionCreator(action, status) {
    switch (status) {
    case 'req':
        return `${action}_REQUEST`;
    case 'res':
        return `${action}_SUCCESS`;
    case 'err':
        return `${action}_FAILED`;
    default:
        return action;
    }
}


/**
 * The role of this function is to get the domain name of website
 * @returns {string} Domain name
 * @example
 *
 *      getAdminWebsite(); // admin.front.flyer.be
 *      => flyer
 *
 * @author Youssef Lahssini
 */
export const getAdminWebsite = () => {
    const { hostname } = window.location;
    const hosts = ['printconcept', 'mercuryflooring'];

    let host = 'printconcept';
    hosts.forEach((h) => {
        if (hostname.includes(h)) {
            host = h;
        }
    });

    return host;
};


/**
 * Moving index inside array by giving old index and new index
 * @param {array} array The array that we want change indexes
 * @param {number} oldIndex Old index
 * @param {number} newIndex New index
 */
export const arrayMove = (array, oldIndex, newIndex) => {
    const result = Array.from(array);
    const [removed] = result.splice(oldIndex, 1);
    result.splice(newIndex, 0, removed);

    return result;
};

/**
 * Check if list has duplicate elements
 * @param {Array} array Array of elements
 * @returns true or false
 */
export const hasDuplicates = (array) => {
    const list = uniq(array);
    if (list.length <= 1) {
        return true;
    }

    return (new Set(list)).size !== list.length;
};


/**
 * This function helps to get the translated value of property based on given locale
 * @param {object} property This is property object that contains the translate array. REQUIRED.
 * @param {string} locale This param represent the locale key (en, fr, nl) that we use it to translate. REQUIRED.
 * @todo It must be filter by resellerID
 * @author Youssef Lahssini
 */
export const getLocalePropertyValue = (property, locale) => {
    if (property) {
        if (typeof property === 'string') {
            return { value: property };
        }

        return (property || []).find(p => p.language === `${PREFIX_LOCALE}${locale}`);
    }

    return '-';
};


/**
 * This function is the native version of 'Translated' component. It return the translated version of given id based on JSON files.
 * @param {string} id The ID of JSON files of locales folder. REQUIRED.
 * @param {string} locale This param represent the locale key (en, fr, nl) that we use it to translate. REQUIRED.
 * @param {object} params The params of the translate ID. OPTIONAL.
 * @author Youssef Lahssini
 */
export const getTranslated = (id, locale, params = {}) => {
    try {
        const assocLocales = {
            en: EN,
            fr: FR,
            nl: NL,
        };

        const intlProvider = new IntlProvider({
            locale: assocLocales[locale].locale,
            messages: assocLocales[locale].messages,
        }, {});
        const { intl } = intlProvider.getChildContext();

        return intl.formatMessage({ id }, params);
    } catch (e) {
        console.log(e);
        return '~~';
    }
};


/**
 * This function return the props of InputNumber component
 * @param {object} props The customize props
 * @author Youssef Lahssini
 */
export function inputNumberProps(props = {}) {
    let precision = 2;

    if (props.removeParser) {
        precision = null;
    } else if (props.step === 1) {
        precision = 0;
    }

    return {
        step: '0.1',
        min: 0,
        precision,
        parser: (value) => {
            let reg = /\$\s?|(,*)/g;

            if (props.step === 1) {
                reg = /\$\s?|(\.|,*)/g;
            }

            if (props.removeParser) {
                return value;
            }

            return value.replace(reg, '');
        },
        size: 'large',
        ...props,
        params: {
            field: props.translated ? getTranslated(props.translated, props.locale) : '',
            number: 0,
            ...props.params,
        },
    };
}


/**
 * Object of operator typing to use it in Rest
 * @param {string} value Value
 * @example
 *
 *      operatorTyping('joe');
 *      * { operator: 'typing', value: 'joe' }
 *
 * @author Youssef Lahssini
 */
export const operatorTyping = value => ({
    operator: 'typing',
    value,
});


/**
 * This function generate object for request api by searching translated value based on locale
 * @param {string} value This param represent the searched value
 * @param {string} locale This param represent the locale key (en, fr, nl) that we use it to translate. REQUIRED.
 * @example
 *
 *      searchElementMatch('fly', 'been');
 *      * { elementMatch: { value: { operator: 'typing', value: 'fly' } }, language: 'been' }
 *
 * @author Youssef Lahssini
 */
export const searchElementMatch = (value, locale = 'nl') => ({
    elementMatch: {
        value: operatorTyping(value),
        language: `${PREFIX_LOCALE}${locale}`,
    },
});


/**
 * This function generate object for request api by searching value. In short, it is a searchElementMatch without locale
 * @param {string} value This param represent the searched value
 * @author Zakaria Louardi
 */
export const searchElementMatchWithoutLanguage = value => (pick(searchElementMatch(value), ['elementMatch.value']));


/**
 * This function return the array of OR operator of rest request
 * @param {Array} fields The list of fields that will include in OR operator query
 * @param {string | string[] | number[]} value The value of search
 * @param {boolean} ignoreCastValue Tells the function to maintain the original value or fields input. It is false by default
 * @example
 *
 *      { or: searchByOrOperator(['first_name', 'last_name'], 'joe') }
 *      * [{ "first_name": { "operator": "typing", "value": "joe" } }, { "last_name": { "operator": "typing", "value": "joe" } }]
 *
 *      { or: searchByOrOperator(['width', 'length'], [60, 40]) }
 *      * [{ "width": [60, 40] }, { "length": [60, 40] }]
 *
 * @author Youssef Lahssini
 */
export const searchByOrOperator = (fields = [], value, ignoreCastValue = false) => {
    const or = [];

    let castValue = parseInt(+value, 10);
    if (isNaN(castValue) || ignoreCastValue) {
        castValue = value;
    }

    fields.forEach((field) => {
        let result = {
            operator: 'typing',
            value: castValue,
        };

        if (typeof castValue === 'number') {
            result = castValue;
        } else if (Array.isArray(value)) {
            result = value;
        }

        or.push({
            [field]: result,
        });
    });

    return or;
};

/**
 * This function is built to execute the ANTD notification with the translating function
 * @param {string} type This param is method of ANTD notification. It support those methods (success, error, warn...)
 * @param {string} locale This param represent the locale key (en, fr, nl) that we use it to translate. REQUIRED.
 * @param {string} messageID This param is the ID of translate. It represent message of notification (Title)
 * @param {string} descriptionID This param is the ID of translate. It represent description of notification (Description)
 * @param {object} params This is an object that we use it to compile params in the translate ID. If we don't want to translate the descriptionID, you must insert in params { noTranslateMsg: true }
 * @param {string} props Props of notification
 * @author Youssef Lahssini
 */
export function setNotification(type, locale, messageID, descriptionID, params = {}, props = {}) {
    notification[type]({
        ...props,
        message: getTranslated(messageID, locale, params),
        description: params.noTranslateMsg ? descriptionID : getTranslated(descriptionID, locale, params),
        duration: 'duration' in params ? params.duration : 8,
    });
}


/**
 * This function cancel action link predefined in Upload component. It called customRequest.
 * @param {Object} param This contains all events of custom request of Upload component
 * @author Zakaria Louardi
 */
export function customRequest({ onSuccess }) {
    setTimeout(() => {
        onSuccess('ok');
        return false;
    }, 0);

    return false;
}

/**
 * This function returns permissions of user.
 * @param {object} permissions This parameter represent the property 'userPermissions' of layout reducer. REQUIERED.
 * @param {string} group This parameter represent the permission group ex (costs, carriers, properties ...). REQUIRED.
 * @author Ayoub Lahraoui & Youssef Lahssini
 */
export function getAccess(permissions, group) {
    try {
        const getRoles = find(permissions?.permissions_groups, i => i.name === group);
        return getRoles ? (getRoles.permissions || []) : [];
    } catch (e) {
        console.log(e);
        return [];
    }
}

/**
 * This function return the list of units of cost for the select.
 * @param {string} locale This param represent the locale key (en, fr, nl) that we use it to translate. REQUIRED.
 * @author Youssef Lahssini
 */
export function getUnitCosts(locale) {
    return [
        { value: 'pieces', text: getTranslated('costs.q.pieces', locale) },
        { value: 'm2', text: getTranslated('costs.q.m2', locale) },
        { value: 'm3', text: getTranslated('costs.q.m3', locale) },
    ];
}

/**
 * This function return the property's value in users listing.
 * @param {string} property This param is the property of iterator of user list. If the property doesn't exist, it will return an emoji. REQUIRED.
 * @param {Array} users This represent the user list. REQUIRED.
 * @param {string} id This is an ID of user that we want an information
 * @author Youssef Lahssini
 */
export function getUserInformations(property, users, id) {
    try {
        // eslint-disable-next-line no-underscore-dangle
        const user = users.find(u => u._id === id);

        if (user) {
            if (property === 'name') {
                return `${user.first_name} ${user.last_name}`;
            }

            return get(user, property, '👹');
        }

        return '-';
    } catch (e) {
        console.log(e);
        return '👹';
    }
}

/**
 * Disable all dates before today. Implemented in disableDate property in Datepicker component
 * @param {*} date Date
 */
export function disableDatesBeforeToday(date) {
    return date && date < moment().subtract(1, 'days').endOf('day');
}

/**
 * Disable all dates after today. Implemented in disableDate property in Datepicker component
 * @param {*} date Date
 */
export function disableDatesAfterToday(date) {
    return date && date > moment().subtract(0, 'days').endOf('day');
}

/**
 * The role of this function is to check the expiration date of user
 * @param {string} expirationDate The format of expiration date is ISO string
 * @returns {boolean}
 * @author Youssef Lahssini
 */
export function checkExpirationDate(expirationDate) {
    if (!expirationDate) {
        return true;
    }

    const now = moment();
    const expire = moment(expirationDate);

    return expire > now;
}


/**
 * The role of this function is to merge objects by a property
 * @param {string} prop The property name that we want to merge the objects
 * @param  {...any} args The objects
 */
export function joinObjectsByProperty(prop, ...args) {
    const idMap = {};

    // Iterate over args
    for (let i = 0; i < args.length; i += 1) {
        // Iterate over individual argument arrays (aka json1, json2)
        for (let j = 0; j < args[i].length; j += 1) {
            const currentID = args[i][j][prop];
            if (!idMap[currentID]) {
                idMap[currentID] = {};
            }

            // Iterate over properties of objects in arrays (aka id, name, etc.)
            for (const key in args[i][j]) {
                idMap[currentID][key] = args[i][j][key];
            }
        }
    }

    // push properties of idMap into an array
    const newArray = [];
    for (const property in idMap) {
        newArray.push(idMap[property]);
    }

    return newArray;
}

/**
 * Strip HTML tags
 * @param {string} text The text that we remove html tags
 * @author Youssef Lahssini
 */
export function StrippedString(text) {
    return text.replace(/(<([^>]+)>)/ig, '');
}


/**
 * The price formatter
 * @param {*} price The price to format
 * @example
 *
 *      priceFormatter(12)
 *      * 12.00
 *
 *      priceFormatter(123.4)
 *      * 123.40
 *
 *      priceFormatter(1234.567)
 *      * 1 234.56
 *
 * @author Youssef Lahssini
 */
export function priceFormatter(price) {
    try {
        return parseFloat(parseFloat(price).toFixed(2).replace(/([0-9]+\.[0-9]{2})([0-9]+)/, '$1')).toString().replace(/\d(?=(\d{3})+\.)/g, '$& ');
    } catch (e) {
        console.log(e);
        return '-';
    }
}

export function pricePrecisionFormatter(price) {
    return priceFormatter(parseFloat(price).toFixed(2));
}

/**
 * Add 0 to number if it is less than or equal 9
 * @param {number} number Number
 * @example
 *
 *      leadingZero(7)
 *      * 07
 *
 *      leadingZero(12)
 *      * 12
 *
 * @author Youssef Lahssini
 */
export function leadingZero(number) {
    return number > 9 ? number : `0${number}`;
}


/**
 * This function return the sell price of custom quantity.
 * This is front version of backend function created by Reda Biya
 * @private
 * @param {object} costSellPrice The cost price quantity
 * @param {number} difference The difference between the custom quantity and the selected quantity
 * @author Youssef Lahssini, Reda Biya
 */
export function calculatePriceOfCustomQuantity(costSellPrice, difference, isPromotion) {
    let multi = difference / (costSellPrice.between_block || 1);

    if (difference % costSellPrice.between_block) {
        // ! Given quantity is not dividable by betweenBlock
        multi = ((difference - (difference % costSellPrice.between_block)) / costSellPrice.between_block) + 1;
    }

    if (isPromotion) {
        if (costSellPrice.between_block === 0) {
            return parseFloat(costSellPrice.promotion_sell_price);
        }

        if (costSellPrice.promotion_sell_price) {
            const betweenPrice = costSellPrice.promotion_between_price || costSellPrice.between_price;
            return parseFloat(costSellPrice.promotion_sell_price) + (betweenPrice * multi);
        }

        return NaN;
    }

    if (costSellPrice.between_block === 0) {
        return parseFloat(costSellPrice.sell_price);
    }

    return parseFloat(costSellPrice.sell_price) + (costSellPrice.between_price * multi);
}


/**
 * Get the sell price object from selected sell price
 * @param {array} sellPrices The list of sell prices (with merged property)
 * @param {string} sellPrice The selected sell price ID
 * @author Youssef Lahssini
 * @returns {array}
 */
export function getSellPricesIDS(sellPrices, sellPrice) {
    const sellprice = sellPrices.find(sp => sp.sell_price_id === sellPrice);

    if (sellprice.merged === undefined || sellprice.merged?.length === 0) {
        return [sellPrice];
    }

    return sellprice.merged.map(sp => sp.sell_price_id);
}


/**
 * Force to float the number if it string
 * @param {string|number} number Number it could be string or number
 * @example
 *
 *      let price = '1 105.50';
 *      forceFloat(price)
 *      * 1105.5
 *
 * @returns {number} Float
 * @author Youssef Lahssini
 */
export function forceFloat(number) {
    return parseFloat(number.toString().replace(/ /g, ''));
}

/**
 * Get width of window object. Given by browser
 */
export const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;


/**
 * This function use YIQ formula that help you to determine whether or not to use a light or dark foreground color.
 * @param {string} color HEX color
 * @returns {string} Return 'black' or 'white'
 * @tutorial https://24ways.org/2010/calculating-color-contrast
 * @example
 *
 *      getColorContrast('#FAA31B');
 *      * black
 *
 *      getColorContrast('#D54799');
 *      * white
 *
 */
export function getColorContrast(color) {
    if (color) {
        const hex = color.replace('#', '');
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

        return (yiq >= 128) ? 'black' : 'white';
    }

    return 'black';
}

export function mergeTwoListsBy(listA, listB, key) {
    try {
        return values(merge(keyBy(listA, key), keyBy(listB, key)));
    } catch (e) {
        console.log(e);
        return [];
    }
}

export async function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function cartesian(firstList, secondList, ...spreads) {
    const fusion = (a, b) => [].concat(...a.map(d => b.map(e => [].concat(d, e))));
    return secondList ? cartesian(fusion(firstList, secondList), ...spreads) : firstList;
}

export function mmToAdminUnit({ admin, value }) {
    if (ADMIN_UNIT[admin] === 'cm') {
        return value / 10;
    }

    return value;
}

export function mToAdminUnit({ admin, value }) {
    if (ADMIN_UNIT[admin] === 'cm') {
        return value * 100;
    }

    return value * 1000;
}

export function adminUnitToMM({ admin, value }) {
    if (ADMIN_UNIT[admin] === 'cm') {
        return value * 10;
    }

    return value;
}

export function isHTML(str) {
    const doc = new DOMParser().parseFromString(str, 'text/html');
    return (
        Array.from(doc.body.childNodes).some(node => node.nodeType === 1)
        || Array.from(doc.head.childNodes).some(node => node.nodeType === 1)
    );
}

export function isJSON(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }

    return true;
}

export function isCSS(str) {
    return /(?:\s*\S+\s*{[^}]*})+/.test(str);
}

export function htmlDecode(input) {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
}

export function mergingReducer(prev, next) {
    return { ...prev, ...next };
}

export function getImg(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = err => reject(err);
        img.src = url;
    });
}
